import { render, staticRenderFns } from "./SurfacePostComment.vue?vue&type=template&id=962a29f6&scoped=true&"
import script from "./SurfacePostComment.vue?vue&type=script&lang=ts&"
export * from "./SurfacePostComment.vue?vue&type=script&lang=ts&"
import style0 from "./SurfacePostComment.vue?vue&type=style&index=0&id=962a29f6&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962a29f6",
  null
  
)

export default component.exports